(function () {
  var root = document.getElementById('SVCartDrawer');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var moneyFormat = root.getAttribute('data-money-format') || 'Rs. {{amount}}';
  var contentEl = root.querySelector('[data-sv-cart-drawer-content]');

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function updateHeaderCartCount(count) {
    var cartLink = document.querySelector('.sv-header__icon[aria-label="Cart"]');
    if (!cartLink) return;
    var countEl = cartLink.querySelector('.sv-header__cart-count');
    if (count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'sv-header__cart-count';
        cartLink.appendChild(countEl);
      }
      countEl.textContent = count;
    } else if (countEl) {
      countEl.remove();
    }
  }

  function open() {
    root.classList.add('is-open');
    document.body.classList.add('sv-cart-open');
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('sv-cart-open');
  }

  // Always re-fetches on open/refresh rather than trusting the page's initial
  // server-render, since the cart can change from another tab or a prior action
  // without a full page reload.
  function refresh() {
    return fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html');
        var freshRoot = fresh.getElementById('SVCartDrawer');
        var freshContent = freshRoot ? freshRoot.querySelector('[data-sv-cart-drawer-content]') : null;
        if (!freshContent) return;
        contentEl.innerHTML = freshContent.innerHTML;
        updateHeaderCartCount(parseInt(freshRoot.getAttribute('data-cart-count'), 10) || 0);
      })
      .catch(function () {
        // Network hiccup — whatever's already in the drawer stays visible;
        // the next successful mutation/open will reconcile it.
      });
  }

  function openAndRefresh() {
    open();
    refresh();
  }

  function showError(message) {
    var existing = contentEl.querySelector('[data-sv-cart-error]');
    if (existing) existing.remove();
    var el = document.createElement('p');
    el.className = 'sv-cart-drawer__error';
    el.setAttribute('data-sv-cart-error', '');
    el.textContent = message;
    contentEl.appendChild(el);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Could not update cart.');
        });
      }
      return response.json();
    });
  }

  // --- Quantity stepper — optimistic update, full section refresh on success,
  // revert + inline error on failure. ------------------------------------------
  document.addEventListener('click', function (event) {
    var decreaseBtn = event.target.closest('[data-sv-cart-decrease]');
    var increaseBtn = event.target.closest('[data-sv-cart-increase]');
    var stepperBtn = decreaseBtn || increaseBtn;

    if (stepperBtn) {
      if (stepperBtn.disabled) return;
      var stepper = stepperBtn.closest('[data-sv-cart-stepper]');
      var valueEl = stepper.querySelector('[data-sv-cart-qty-value]');
      var priceEl = stepper.closest('[data-sv-cart-item]').querySelector('[data-sv-cart-line-price]');
      var key = stepper.getAttribute('data-line-key');
      var unitPrice = parseInt(stepper.getAttribute('data-unit-price'), 10) || 0;
      var currentQty = parseInt(valueEl.textContent, 10) || 1;
      var newQty = decreaseBtn ? Math.max(1, currentQty - 1) : currentQty + 1;

      if (newQty === currentQty) return;

      valueEl.textContent = newQty;
      if (priceEl) priceEl.textContent = formatMoney(unitPrice * newQty);
      stepper.querySelectorAll('[data-sv-cart-decrease], [data-sv-cart-increase]').forEach(function (btn) {
        btn.disabled = true;
      });

      changeLine(key, newQty)
        .then(function () {
          refresh();
        })
        .catch(function (error) {
          valueEl.textContent = currentQty;
          if (priceEl) priceEl.textContent = formatMoney(unitPrice * currentQty);
          stepper.querySelectorAll('[data-sv-cart-decrease], [data-sv-cart-increase]').forEach(function (btn) {
            btn.disabled = false;
          });
          showError(error.message);
        });
      return;
    }

    var removeBtn = event.target.closest('[data-sv-cart-remove]');
    if (removeBtn) {
      var itemEl = removeBtn.closest('[data-sv-cart-item]');
      var removeKey = removeBtn.getAttribute('data-line-key');
      itemEl.classList.add('is-removing');

      changeLine(removeKey, 0)
        .then(function () {
          refresh();
        })
        .catch(function (error) {
          itemEl.classList.remove('is-removing');
          showError(error.message);
        });
      return;
    }

    // Checkout hook: a third-party checkout (e.g. Breeze) can listen for this event
    // and call event.preventDefault() to take over. If nothing handles it, the
    // link's own href="/checkout" runs as normal.
    if (event.target.closest('.sv-cart-drawer__checkout')) {
      var checkoutEvent = new CustomEvent('sv:cart-checkout', {
        cancelable: true,
        detail: { source: 'cart-drawer' }
      });
      if (!document.dispatchEvent(checkoutEvent)) event.preventDefault();
      return;
    }

    if (event.target.closest('[data-sv-cart-open]')) {
      event.preventDefault();
      openAndRefresh();
      return;
    }

    if (event.target.closest('[data-sv-cart-close]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  // Fired by sv-product-buybox.js, sv-quick-add.js, and sv-sticky-atc.js after a
  // successful /cart/add.js — opens the drawer to show what was just added
  // (fulfills the "open cart drawer after add" TODO left in sv-quick-add.js).
  document.addEventListener('sv:cart:updated', openAndRefresh);
})();
